import React from "react";
import PropTypes from "prop-types";
import ContainerWrapperIntern from "../ContainerWrapperIntern";
import PFContainer from "./PFContainer";

const PFContainerWrapper = props => {
  return <ContainerWrapperIntern {...props} Container={PFContainer}></ContainerWrapperIntern>;
};

PFContainerWrapper.propTypes = {
  value: PropTypes.any,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  onTextFieldChange: PropTypes.func.isRequired,
  helperText: PropTypes.string,
  required: PropTypes.bool,
  iconHidden: PropTypes.bool,
  error: PropTypes.bool,
  hasCustomIcons: PropTypes.bool,
  iconDisabled: PropTypes.bool,
  customEndIcons: PropTypes.node
};

export default PFContainerWrapper;
